import './TableOrderPage.scss'
import React from 'react'

import Placeholder from 'src/assets/images/newDesign/placeholder.svg'
import Money from 'src/components/Money/Money'

const ItemCard = ({ productId, code, name, price, url, onClick, dataCy }) => {
  return (
    <div
      key={productId}
      className={'pos-item a-in-opacity'}
      onClick={onClick}
      data-cy={dataCy}>
      <img className={'pos-item-img'} src={url ? url : Placeholder} alt={name} />
      <div className={'pos-item-data'}>
        <div className={'pos-item-label'}>
          <div className={'pos-item-name b-user-name'}>
            {name.length > 45 ? name.substring(0, 45) + '...' : name}
          </div>
          <h6 className={'pos-item-code b-user-email'}>{code}</h6>
        </div>

        <Money component="h5" className={'pos-item-price'}>
          {price}
        </Money>
      </div>
    </div>
  )
}
export default ItemCard
